import { createSlice } from "@reduxjs/toolkit";

type DiscountInfoType = {
  type: string;
  value: number;
  startDate: string | Date | null;
  endDate: string | Date | null;
  products?: string[];
};

interface Pagination {
  page: number;
  limit: number;
  total: number;
}

type initialStateType = {
  jewellery: Object | null;
  jewelleries: Object[];
  jewelleryDiscountModel: Object[];
  selectedProducts: Object[];
  discounts: Object[];
  errors: {};
  isLoading: boolean;
  isEditing: boolean;
  totalCount: number;
  limit: number;
  currentPage: number;
  discountInfo: DiscountInfoType; // Store selected product IDs.
  pagination: Pagination;
  isCompleted: boolean;
};

export const initialState: initialStateType = {
  jewellery: null,
  jewelleries: [],
  jewelleryDiscountModel: [],
  selectedProducts: [],
  discounts: [],
  errors: {},
  isLoading: false,
  isEditing: false,
  totalCount: 0,
  limit: 10,
  currentPage: 1,
  discountInfo: {
    type: "",
    value: 0,
    startDate: null,
    endDate: null,
    products: [],
  }, // Store selected product IDs.
  pagination: {
    page: 1,
    limit: 10,
    total: 0,
  },
  isCompleted: false,
};

const DicountSlice = createSlice({
  name: "Discount",
  initialState,
  reducers: {
    setIsLoading: (state: initialStateType, action: { payload: boolean }) => {
      state.isLoading = action.payload;
    },
    setIsEditing: (state: initialStateType, action: { payload: boolean }) => {
      state.isEditing = action.payload;
    },
    setTotalCount: (state, action: { payload: number }) => {
      state.totalCount = action.payload;
    },
    setLimit: (state, action: { payload: number }) => {
      state.limit = action.payload;
    },
    setCurrentPage: (state, action: { payload: number }) => {
      state.currentPage = action.payload;
    },
    setPagination: (state, action: { payload: Pagination }) => {
      state.pagination = action.payload;
    },

    //Discount

    setSelectedProducts(state, action) {
      const productId = action.payload;
      if (!Array.isArray(state.selectedProducts)) {
        state.selectedProducts = []; // Ensure it’s an array
        return;
      }
      state.selectedProducts = action.payload; // Ensure it’s an array

      // if (state.selectedProducts.includes(productId)) {
      //   state.selectedProducts = state.selectedProducts.filter((id) => id !== productId);
      // } else {
      //   state.selectedProducts.push(productId);
      // }
    },

    resetSelectedProducts: (state) => {
      state.selectedProducts = [];
      // state.jewelleries = [];
    },

    setDiscountInfo: (
      state,
      action: { payload: Partial<DiscountInfoType> }
    ) => {
      // Merge new payload values, including adding products if provided
      state.discountInfo = {
        ...state.discountInfo,
        ...action.payload,
        // products: [
        //   ...(state.discountInfo.products || []), // Existing products
        //   ...(action.payload.products || []), // New products from payload
        // ],
      };
    },

    updateDiscountInfo: (
      state,
      action: { payload: { id: string; fields: Partial<DiscountInfoType> } }
    ) => {
      // Logic for handling updates
      state.discountInfo = {
        ...state.discountInfo,
        ...action.payload.fields,
      };
    },

    addDiscountSuccess: (state: initialStateType, action: any) => {
      state.discounts.unshift(action.payload); // Add a new discount
    },
    addDiscountError: (state: initialStateType, action: any) => {
      state.errors = action?.payload || null; // Handle error
    },
    getDiscountsSuccess: (state: initialStateType, action: any) => {
      state.discounts = action.payload; // Fetch all discounts
    },
    getDiscountsError: (state: initialStateType, action: any) => {
      state.errors = action.payload; // Handle error
    },
    updateDiscountSuccess: (state: initialStateType, action: any) => {
      state.discounts = state.discounts.map((discount: any) =>
        discount._id === action.payload._id
          ? { ...discount, ...action.payload } // Update discount
          : discount
      );
    },
    updateDiscountError: (state: initialStateType, action: any) => {
      state.errors = action?.payload || null; // Handle error
    },
    deleteDiscountSuccess: (state: initialStateType, action: any) => {
      state.discounts = state.discounts.filter(
        (discount: any) => discount._id !== action.payload // Delete discount
      );
    },
    deleteDiscountError: (state: initialStateType, action: any) => {
      state.errors = action?.payload || null; // Handle error
    },
    getJewelleryDiscountModelSuccess: (
      state: initialStateType,
      action: any
    ) => {
      const newProducts = action.payload.filter(
        (newProduct: any) =>
          !state.jewelleryDiscountModel.some(
            (existingProduct: any) => existingProduct._id === newProduct._id // Replace `_id` with your unique key
          )
      );
      state.jewelleryDiscountModel =
        state.jewelleryDiscountModel.concat(newProducts);
    },
    getJewelleryDiscountModelError: (state: initialStateType, action: any) => {
      state.jewelleryDiscountModel = action.payload;
    },
  },
});

export default DicountSlice.reducer;
export const {
  setTotalCount,
  setLimit,
  setCurrentPage,
  setPagination,
  setIsLoading,
  setIsEditing,
  setDiscountInfo,
  updateDiscountInfo,
  getJewelleryDiscountModelSuccess,
  getJewelleryDiscountModelError,
  addDiscountSuccess,
  addDiscountError,
  getDiscountsSuccess,
  getDiscountsError,
  updateDiscountSuccess,
  updateDiscountError,
  setSelectedProducts,
  resetSelectedProducts,
} = DicountSlice.actions;
